module.exports = __webpack_public_path__ + "static/media/corporate-services-img65.a73cb52b.jpg";